module.exports = __webpack_public_path__ + "825a2f51f0c3c54cd415c5b2b575c116.pdf";